<template>
  <v-sheet
    style="cursor: pointer; border: 1px solid grey; border-radius: 5px;"
    :key="team.id"
    @click="show = true"
  >
    <v-row class="d-flex align-center py-6 px-8">
      <v-sheet class="text-button d-flex align-center">
        {{team.team_name}}
      </v-sheet>
      <v-spacer></v-spacer>
      <v-sheet v-if="plan">
        <v-chip v-if="plan.epesis_pro" color="primary">Pro</v-chip>
        <v-chip v-else>Perus</v-chip>
      </v-sheet>
      <v-sheet v-else>
        <v-chip color="red">Ei plan</v-chip>
      </v-sheet>
      <v-chip v-if="team.closed" color="red" class="ml-2">Suljettu</v-chip>

      <!-- Admin Message Indicator -->
      <v-tooltip bottom v-if="team.admin_message">
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            color="warning"
            class="ml-2"
            v-bind="attrs"
            v-on="on"
          >
            mdi-message-text
          </v-icon>
        </template>
        <div style="max-width: 250px;">
          <div class="font-weight-bold mb-1">Ylläpidon viesti:</div>
          <div>{{ team.admin_message }}</div>
        </div>
      </v-tooltip>

      <!-- Closed Reason Indicator -->
      <v-tooltip bottom v-if="team.closed_reason">
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            color="error"
            class="ml-2"
            v-bind="attrs"
            v-on="on"
          >
            mdi-alert-circle
          </v-icon>
        </template>
        <div style="max-width: 250px;">
          <div class="font-weight-bold mb-1">Sulkemisen syy:</div>
          <div>{{ team.closed_reason }}</div>
        </div>
      </v-tooltip>
      <!-- <v-chip @click.stop class="mr-4">
        <div v-if="showJoinCode">
          {{team.join_code}}
        </div>
        <div v-else>
          ******
        </div>
        <v-icon @click.stop="showJoinCode = !showJoinCode" class="ml-3" v-if="showJoinCode">mdi-eye-off-outline</v-icon>
        <v-icon @click.stop="showJoinCode = !showJoinCode" class="ml-3" v-else>mdi-eye-outline</v-icon>
      </v-chip> -->
      <!-- {{team.id}} -->
      <!-- <v-btn @click="show = true" class="mr-5" small rounded>
        <v-icon>mdi-pencil-outline</v-icon>
      </v-btn> -->
    </v-row>
    <!-- {{team}} -->




    <v-dialog max-width="800" v-model="show">
      <v-sheet class="pa-8">
        <v-sheet class="text-button">
          {{team.team_name}}
        </v-sheet>
        <v-chip color="" outlined label>
          Team Id: {{ team.id }}
        </v-chip>
        <v-chip color="" outlined class="ml-2" label>
          Created: {{ team.created }}
        </v-chip>
        <v-chip color="" outlined class="ml-2" label>
          Join code: {{ team.join_code }}
        </v-chip>
        <v-chip v-if="team.closed" color="red" class="ml-2" label>
          Tila: Suljettu
        </v-chip>
        <v-chip v-else color="green" class="ml-2" label>
          Tila: Avoin
        </v-chip>

        <v-sheet class="mt-4">
          <v-btn
            :color="team.closed ? 'green' : 'red'"
            @click="toggleTeamStatus"
            :loading="loadingToggle"
            class="mb-4"
          >
            <v-icon class="mr-2">{{ team.closed ? 'mdi-lock-open' : 'mdi-lock' }}</v-icon>
            {{ team.closed ? 'Avaa tiimi' : 'Sulje tiimi' }}
          </v-btn>
        </v-sheet>

        <v-sheet class="mt-4">
          <v-sheet class="text-subtitle-1 mb-2">Sulkemisen syy</v-sheet>
          <v-sheet v-if="!editingClosedReason" class="d-flex align-center">
            <v-sheet class="flex-grow-1 pa-3" style="background-color: #f5f5f5; border-radius: 4px; min-height: 40px;">
              {{ team.closed_reason }}
            </v-sheet>
            <v-btn icon @click="startEditClosedReason" class="ml-2">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-sheet>
          <v-sheet v-else class="d-flex align-center">
            <v-textarea
              v-model="editingClosedReasonText"
              solo
              dense
              rows="2"
              placeholder="Syötä sulkemisen syy..."
              class="flex-grow-1"
            ></v-textarea>
            <v-btn icon @click="saveClosedReason" :loading="loadingClosedReason" class="ml-2">
              <v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn icon @click="cancelEditClosedReason" class="ml-1">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-sheet>
        </v-sheet>

        <v-sheet class="mt-4">
          <v-sheet class="text-subtitle-1 mb-2">Ylläpidon viesti</v-sheet>
          <v-sheet v-if="!editingAdminMessage" class="d-flex align-center">
            <v-sheet class="flex-grow-1 pa-3" style="background-color: #f5f5f5; border-radius: 4px; min-height: 40px;">
              {{ team.admin_message }}
            </v-sheet>
            <v-btn icon @click="startEditAdminMessage" class="ml-2">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-sheet>
          <v-sheet v-else class="d-flex align-center">
            <v-textarea
              v-model="editingAdminMessageText"
              solo
              dense
              rows="2"
              placeholder="Syötä ylläpidon viesti..."
              class="flex-grow-1"
            ></v-textarea>
            <v-btn icon @click="saveAdminMessage" :loading="loadingAdminMessage" class="ml-2">
              <v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn icon @click="cancelEditAdminMessage" class="ml-1">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-sheet>
        </v-sheet>

        <v-sheet class="mt-2">
          <v-select :value="team.plan_id" @change="changePlan" solo dense :items="plans" item-text="full_name" item-value="id">
            <template v-slot:selection="{ item }">
              <LeagueTeamPlan :item="item"></LeagueTeamPlan>
            </template>
            <template v-slot:item="{ item }">
              <LeagueTeamPlan :item="item"></LeagueTeamPlan>
            </template>
          </v-select>
        </v-sheet>
        <v-sheet class="text-button d-flex align-center mt-10">
          Käyttäjät
        </v-sheet>
        <v-sheet style="min-height: 100px;">
          <v-sheet v-if="!loading_team_users">
            <league-team-user
              v-for="user in team_users"
              :key="user.id"
              :team_user="user"
              :team_id="team.id"
            ></league-team-user>
          </v-sheet>
          <v-sheet v-else class="pa-5 pt-10 d-flex justify-center">
            <v-progress-circular color="grey" indeterminate />
          </v-sheet>
        </v-sheet>
      </v-sheet>
    </v-dialog>
  </v-sheet>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LeagueTeamUser from './LeagueTeamUser.vue'
import LeagueTeamPlan from './LeagueTeamPlan.vue';
import a from '@/utils/axios/axios'

export default {
  components: { LeagueTeamUser, LeagueTeamPlan },
  props: ['team'],
  data: () => ({
    showJoinCode: false,
    show: false,
    loadingToggle: false,
    loadingClosedReason: false,
    loadingAdminMessage: false,
    editingClosedReason: false,
    editingAdminMessage: false,
    editingClosedReasonText: '',
    editingAdminMessageText: ''
  }),
  mounted() {
    this.getTeamUsers({ id: this.team.id })

    if(!this.plans || !this.plans.length) {
      this.initPlans()
    }
  },
  methods: {
    ...mapActions('admin', [
      'getTeamUsers',
      'changeTeamPlan'
    ]),
    ...mapActions('auth', [
      'initPlans'
    ]),
    ...mapActions('noti', [
      'success',
      'error'
    ]),
    changePlan(id) {
      this.changeTeamPlan({ team_id: this.team.id, plan_id: id })
        .then(() => {
          this.success('Suunnitelma vaihdettu')
        })
        .catch(() => {
          this.error('Suunnitelman vaihto epäonnistui')
        })
    },
    async toggleTeamStatus() {
      this.loadingToggle = true
      try {
        const response = await a.patch(`/team/${this.team.id}`, { closed: !this.team.closed })
        this.team.closed = response.data.closed
        this.success(response.data.message)
      } catch (error) {
        this.error('Tiimin tilan vaihto epäonnistui')
      } finally {
        this.loadingToggle = false
      }
    },
    startEditClosedReason() {
      this.editingClosedReasonText = this.team.closed_reason || ''
      this.editingClosedReason = true
    },
    async saveClosedReason() {
      this.loadingClosedReason = true
      try {
        const response = await a.patch(`/team/${this.team.id}`, {
          closed_reason: this.editingClosedReasonText
        })
        this.team.closed_reason = response.data.closed_reason
        this.editingClosedReason = false
        this.success('Sulkemisen syy päivitetty')
      } catch (error) {
        this.error('Sulkemisen syyn päivitys epäonnistui')
      } finally {
        this.loadingClosedReason = false
      }
    },
    cancelEditClosedReason() {
      this.editingClosedReason = false
      this.editingClosedReasonText = ''
    },
    startEditAdminMessage() {
      this.editingAdminMessageText = this.team.admin_message || ''
      this.editingAdminMessage = true
    },
    async saveAdminMessage() {
      this.loadingAdminMessage = true
      try {
        const response = await a.patch(`/team/${this.team.id}`, {
          admin_message: this.editingAdminMessageText
        })
        this.team.admin_message = response.data.admin_message
        this.editingAdminMessage = false
        this.success('Ylläpidon viesti päivitetty')
      } catch (error) {
        this.error('Ylläpidon viestin päivitys epäonnistui')
      } finally {
        this.loadingAdminMessage = false
      }
    },
    cancelEditAdminMessage() {
      this.editingAdminMessage = false
      this.editingAdminMessageText = ''
    }
  },
  computed: {
    ...mapGetters('admin', [
      'loading_team_users',
      'team_users'
    ]),
    ...mapGetters('auth', [
      'plans'
    ]),
    plan() {
      if(!this.plans || !this.plans.length) return {}
      return this.plans.find(p => p.id === this.team.plan_id)
    }
  },
  watch: {
    'show': {
      handler(newVal) {
        if(newVal) this.getTeamUsers({ id: this.team.id })
      }
    }
  }
}
</script>